<template>
  <div class="divPage">
    <div>
      <div class="divItem">
        <b-row>
          <b-col> 订单状态：<span>等待申请人付款</span> </b-col>
        </b-row>
        <b-row>
          <b-col>
            您的图片已提交，请在24小时内完成支付，超时订单将自动取消
          </b-col>
        </b-row>
      </div>
      <div class="divItem">
        <h6>付款商品</h6>
        <hr />
        <b-row>
          <b-col cols="4">
            <img :src="thumbnailSrc" style="width: 64px" />
          </b-col>
          <b-col cols="5" class="rightText">版面定制服务费</b-col>
          <b-col cols="3" class="rightText"
            >￥{{ orderInfoObj == null ? "" : orderInfoObj.price / 100 }}</b-col
          >
        </b-row>
      </div>

      <div class="divItem">
        <b-row>
          <b-col>
            <b-form-input
              v-model="voucherCode"
              id="input-voucher-code"
              type="text"
              placeholder="请输入优惠券码"
            ></b-form-input>
          </b-col>
        </b-row>
      </div>

      <div class="divItem">
        <h6>结算</h6>
        <hr />
        <b-row>
          <b-col class="rightText"
            >应付总额：￥{{
              orderInfoObj == null ? "" : orderInfoObj.price / 100
            }}</b-col
          >
        </b-row>
      </div>

      <div class="divItem">
        <h6>订单信息</h6>
        <hr />
        <b-row>
          <b-col
            >订单编号：<span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderNo
            }}</span></b-col
          >
        </b-row>
        <b-row>
          <b-col
            >下单时间：<span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderDateTime
            }}</span></b-col
          >
        </b-row>
      </div>

      <div class="divItemNotice">
        <h6>温馨提示</h6>
        <div>1.支付后，将无法更改以上卡片定制信息</div>
        <div>2.我们将在30个工作日左右为您寄送卡片，请注意查收</div>

        <div class="divItem">
          <b-row>
            <!-- <b-col cols="10" class="mx-auto payBtn">
              <b-button
                block
                variant="danger"
                @click="wxH5Pay()"
                v-preventReClick
                >微信支付</b-button
              >
            </b-col> -->
            <b-col cols="10" class="mx-auto payBtn">
              <b-button
                v-show="true"
                block
                variant="danger"
                @click="aliH5Pay()"
                v-preventReClick
                >支付宝支付</b-button
              >
            </b-col>
            <b-col cols="10" class="mx-auto replaceBtn">
              <b-button block variant="primary" @click="replaceCardface()"
                >更改图片</b-button
              >
            </b-col>
          </b-row>
        </div>

        <!-- loading toast -->
        <div v-show="loading">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <i class="weui-loading weui-icon_toast"></i>
            <p class="weui-toast__content">下单中</p>
          </div>
        </div>
        <div v-show="showToast">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
            <p class="weui-toast__content">{{ toastMsg }}</p>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
      centered
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <b-modal
      ref="model_pay_result"
      title="提示"
      ok-title="已完成支付"
      @ok="doneWxH5Pay()"
      cancel-title="支付遇到问题，重新支付"
      @cancel="reWxH5Pay()"
      no-close-on-esc
      centered
      :hide-header-close="true"
    >
      <p>请确认支付是否已完成?</p>
    </b-modal>
    <b-modal
      ref="model_back_ios_app"
      title="提示"
      ok-title="确定"
      @ok="backToIosApp()"
      no-close-on-esc
      ok-only
      centered
      :hide-header-close="true"
    >
      <p>请返回手机银行App,确认支付结果。</p>
    </b-modal>
  </div>
</template>

<script>
import { generateRandomNumericString } from "@/js/verifyData";
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "OrderPay_hongcheng",
  data() {
    return {
      orderInfoObj: null,
      appid: "",
      appid_aliH5: "",
      code: "",
      thumbnailSrc: "",
      loading: false,
      showToast: false,
      toastMsg: "",
      targetUrl: "",
      voucherCode: "",
      errorMsg: "",
      faceValue: "",
      practicalAmt: "",
      originalAmt: "",
    };
  },
  watch: {
    voucherCode: function (newval, oldval) {
      console.log("newval->", newval);
      console.log("oldval->", oldval);
      if (newval == "") {
        this.faceValue = "";
        this.practicalAmt = "";
        this.originalAmt = "";
      }

      console.log("faceValue->", this.faceValue);
    },
  },
  destroyed: function () {
    this.clearWxH5payState();
  },
  methods: {
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    toOrderResult: function () {
      this.$router.replace({
        name: "OrderResult_hongcheng",
        params: {},
      });
    },

    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    /* 
    @param voucherValue,优惠券面额
    @orderPrice 订单金额
     */
    caculatePriceWidthVoucher(voucherValue, orderPrice) {
      let price = orderPrice - voucherValue;
      if (price < 0) {
        return 0;
      }
      return price;
    },
    initH5PayAction() {
      var that = this;
      var formData = new FormData();
      formData.append("bankCode", "default");
      formData.append("type", "1");
      axios({
        method: "post",
        url: config.config_hongcheng.initH5Pay,
        data: formData,
      })
        .then(function (response) {
          var result = response.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          let data = result.data;
          that.appid = data.appid;
          that.wxH5PayAction();
        })
        .catch(function (error) {
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    queryVoucher: function () {
      //检查优惠券
      var that = this;
      axios
        .get(config.config_hongcheng.queryVoucher, {
          params: {
            bankCode: this.orderInfoObj.bankCode,
            voucherCode: this.voucherCode,
            cardTypeId: this.orderInfoObj.cardTypeId,
          },
        })
        .then(function (response) {
          console.log(response);
          var result = response.data;
          //{code: 103, message: "未找到对应的优惠券信息", faceValue: 0, practicalAmt: 0, originalAmt: 0}
          if (result.code == 0) {
            that.faceValue = result.faceValue;
            // that.practicalAmt = result.practicalAmt;
            // that.originalAmt = result.originalAmt;
            let price = that.caculatePriceWidthVoucher(
              result.faceValue,
              that.orderInfoObj.price
            );
            that.unifyOrderWithVoucher(price);
          } else {
            that.errorMsg = result.message;
            that.showErrorMsg();
          }
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },
    aliH5Pay() {
      // this.unifyOrder_aliH5();
      // 获取APPID
      this.getZFB_H5_Appid();
    },
    getZFB_H5_Appid() {
      let that = this;
      var formData = new FormData();
      formData.append("bankCode", "0131");
      axios({
        method: "post",
        url: config.config_commonPay.initAilPay,
        data: formData,
      })
        .then(function (response) {
          var result = response.data;
          if (result.code != 0) {
            //失败
            that.errorMsg = "获取appID失败";
            that.showErrorMsg();
            return;
          }
          let data = result.data;
          that.appid_aliH5 = data.appId;
          let appId_ali = data.appId;
          that.unifyOrder_aliH5(appId_ali);
        })
        .catch(function (error) {
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    unifyOrder_aliH5: function (appId_ali) {
      var that = this;
      // var myObj = {
      //   paySource: this.orderInfoObj.projectName,
      //   payChannelType: 3,
      //   orderNo: this.orderInfoObj.orderNo,
      //   bankCode: this.orderInfoObj.bankCode,
      //   deadline: this.orderInfoObj.deadline, //支付截至日期
      //   voucherCode: this.voucherCode, //电子券
      //   faceValue: this.faceValue,
      //   payAmt: this.orderInfoObj.price,
      //   returnUrl: window.location.href,
      //   // appId: this.appid_aliH5,
      //   appId: appId_ali,
      //   payMethod: "ali",
      // };
      var myObj = {
        // paySource: this.orderInfoObj.projectName,
        paySource: "DIY",
        payChannelType: 3, //
        orderId: this.orderInfoObj.orderNo, //
        bankCode: this.orderInfoObj.bankCode, //
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        // faceValue: this.faceValue,
        faceValue: "",
        payAmt: this.orderInfoObj.price,
        returnUrl: window.location.href,
        // appId: this.appid_aliH5,
        appId: appId_ali,
        // payMethod: "ali",
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();
      axios
        .post(config.config_commonPay.aliPayH5, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            let result = data.data;
            that.$router.replace({
              name: "AlipayH5_hongcheng",
              params: { pageHtml: result },
            });
          } else {
            that.errorMsg = data.message;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    wxH5Pay: function () {
      this.initH5PayAction();
    },
    wxH5PayAction() {
      if (this.voucherCode == "") {
        this.unifyOrder();
      } else {
        this.queryVoucher();
      }
    },
    replaceCardface: function () {
      let randomNumericString = generateRandomNumericString(6);
      sessionStorage.setItem("userId", randomNumericString);
      this.$store.commit("hongcheng/reuploadImg");
      var param = {
        isModify: 1,
        orderNo: this.orderInfoObj.orderNo,
        backgroundColor: this.orderInfoObj.backgroundColor,
        isPayed: false,
      };

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.push({
        name: "SelectCardface_hongcheng",
        params: {
          selectParam: selectParam,
        },
      });
    },
    starToPay: function (payargs) {
      this.setWxH5payState();
      //{"code":0,"msg":"成功","data":{"timeStamp":"1706582624","h5url":"https://wx.tenpay.com/cgi-bin/mmpayweb-bin/checkmweb?prepay_id=wx30104344445466d0fea7a575e018120000&package=4145400295","package":"prepay_id=wx30104344445466d0fea7a575e018120000","appId":"","sign":"","signType":"MD5","nonceStr":""}}
      if (this.isIOS()) {
        let url = window.location.href;
        //ios徽商银行DIY手机银行入口h5支付跳转redirect_url
        // let paySuccessUrl = "https://pbank.hsbank.cc/app/";
        let paySuccessUrl = url;
        let h5url = `${payargs.h5url}&redirect_url=${encodeURIComponent(
          paySuccessUrl
        )}`;
        // let h5url = `${payargs.h5url}&redirect_url=${encodeURIComponent(url)}`;
        window.location.href = h5url;
      } else {
        let h5url = payargs.h5url;
        window.location.href = h5url;
      }
    },

    isIOS() {
      let equipmentType = "";
      let agent = navigator.userAgent.toLowerCase();
      let iphone = agent.indexOf("iphone");
      let ipad = agent.indexOf("ipad");
      if (iphone != -1 || ipad != -1) {
        equipmentType = "ios";
      }
      return equipmentType == "ios";
    },
    unifyOrderWithVoucher: function (discountedPrice) {
      var that = this;
      // var myObj = {
      //   hbTradeType: 3, //H5支付
      //   openId: "",
      //   orderNo: this.orderInfoObj.orderNo,
      //   totalFee: discountedPrice,
      //   pay_source: this.orderInfoObj.projectName,
      //   bankCode: this.orderInfoObj.bankCode,
      //   deadline: this.orderInfoObj.deadline, //支付截至日期
      //   voucherCode: this.voucherCode, //电子券
      //   faceValue: this.faceValue,
      //   // practicalAmt: this.practicalAmt,
      //   orderAmt: this.orderInfoObj.price,
      //   appId: this.appid,
      //   payMethod: "wechat",
      // };

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo,
        total_fee: discountedPrice,
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price,
        appid: this.appid,
      };
      console.log(JSON.stringify(myObj));
      that.showLoading();
      axios
        .post(config.config_hongcheng.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              if (that.orderInfoObj.price == 0) {
                //0元，无需支付，直接跳转到订单结果页面
                that.toOrderResult();
              } else {
                that.starToPay(payargs);
              }
            }
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
    backToIosApp() {
      // let hsbankApp = "https://pbank.hsbank.cc/app/";
      let hsbankApp = "";
      window.location.href = hsbankApp;
    },
    showIosBackTip() {
      this.$refs["model_back_ios_app"].show();
    },
    showPayResult() {
      this.$refs["model_pay_result"].show();
    },
    setWxH5payState() {
      sessionStorage.setItem("wxh5pay", "paying");
    },
    getWxH5payState() {
      return sessionStorage.getItem("wxh5pay");
    },
    clearWxH5payState() {
      sessionStorage.removeItem("wxh5pay");
    },
    reWxH5Pay() {
      this.clearWxH5payState();
      this.wxH5Pay();
    },
    doneWxH5Pay() {
      this.clearWxH5payState();
      this.toOrderResult();
    },
    unifyOrder: function () {
      var that = this;
      // var myObj = {
      //   hbTradeType: 3, //H5支付
      //   openId: "",
      //   orderNo: this.orderInfoObj.orderNo,
      //   totalFee: this.orderInfoObj.price,
      //   pay_source: this.orderInfoObj.projectName,
      //   bankCode: this.orderInfoObj.bankCode,
      //   deadline: this.orderInfoObj.deadline, //支付截至日期
      //   voucherCode: this.voucherCode, //电子券
      //   faceValue: this.faceValue,
      //   // practicalAmt: this.practicalAmt,
      //   orderAmt: this.orderInfoObj.price,
      //   appId: this.appid,
      //   payMethod: "wechat",
      // };
      var myObj = {
        hbTradeType: 3,
        openid: "",
        order_id: this.orderInfoObj.orderNo,
        total_fee: this.orderInfoObj.price, //支付金额
        pay_source: this.orderInfoObj.projectName,
        bankCode: this.orderInfoObj.bankCode,
        deadline: this.orderInfoObj.deadline, //支付截至日期
        voucherCode: this.voucherCode, //电子券
        faceValue: this.faceValue,
        // practicalAmt: this.practicalAmt,
        orderAmt: this.orderInfoObj.price, //订单金额
        appid: this.appid,
      };

      console.log(JSON.stringify(myObj));
      that.showLoading();

      axios
        .post(config.config_hongcheng.unifiedOrder, myObj)
        .then(function (response) {
          that.hideLoading();
          console.log(response);
          var data = response.data;
          if (data.code == 0) {
            var payargs = data.data;
            console.log(payargs);
            if (payargs == undefined) {
              //优惠券金额与制卡费用相等，无需支付，直接跳转到订单结果页面
              that.toOrderResult();
            } else {
              //需要支付
              that.starToPay(payargs);
            }
          } else {
            that.errorMsg = data.msg;
            that.showErrorMsg();
            //that.showToastMsg(data.message);
          }
        })
        .catch(function (error) {
          that.hideLoading();
          console.log(error);
          that.errorMsg = `${error.message}`;
          that.showErrorMsg();
        });
    },
  },
  mounted: function () {
    /* {
         orderNo: '01248790113566597120',
         orderDateTime: '2020-05-22 09:39:22',
         price: 1,
         projectName: 'DIY',
         thumbnailFileUrl: ''
       } */

    var orderInfo = this.$route.params.orderInfo;
    if (orderInfo !== undefined) {
      this.orderInfoObj = JSON.parse(orderInfo);
      sessionStorage.setItem("orderInfo", orderInfo);
    } else {
      var orderInSession = sessionStorage.getItem("orderInfo");
      this.orderInfoObj = JSON.parse(orderInSession);
    }

    let wxH5state = this.getWxH5payState();
    console.log("wxH5state->", wxH5state);
    if (wxH5state == "paying") {
      //wxh5支付返回后，页面重新加载
      this.showPayResult();
    } else {
      //ios微信h5支付，支付或未支付返回时，跳转回app兼容方案
      // console.log("orderInfoObj is null", this.orderInfoObj == null);
      if (this.isIOS() && this.orderInfoObj == null) {
        this.showIosBackTip();
      }
    }

    console.log(this.orderInfoObj);
    this.thumbnailSrc =
      config.config_hongcheng.baseImgUrl + this.orderInfoObj.thumbnailFileUrl;
    console.log("thumbnailSrc:" + this.thumbnailSrc);
  },
};
</script>

<style scoped>
.payBtn {
  margin-top: 16px;
}

.replaceBtn {
  margin-top: 16px;
  margin-bottom: 24px;
}

.divItem {
  margin-top: 16px;
  background-color: white;
  padding: 8px;
}

.divItemNotice {
  margin-top: 16px;
  padding: 8px;
}

.rightText {
  text-align: right;
}

.divPage {
  background-color: #f1f2f3;
}
</style>



// WEBPACK FOOTER //
// src/components/hongcheng/OrderPay_hongcheng.vue